import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import ELCTable from "../../components/ELCTable/ELCTable";
import "./ELCDashboard.scss";
import ELCDatePicker from "../../components/ELCDatePicker/ELCDatePicker";
import { useDispatch } from "react-redux";
import {
  fetchBGCCounts,
  fetchPreOfferCounts,
  fetchSLACounts,
} from "@workspace/job/src/store/actions";
import PreOfferCountCard from "./CountCards/PreOfferCountCard";
import OfferCreationCountCard from "./CountCards/OfferCreationCountCard";
import OfferReviewCountCard from "./CountCards/OfferReviewCountCard";
import ShareOfferCountCard from "./CountCards/ShareOfferCountCard";
import OfferApprovalCountCard from "./CountCards/OfferApprovalCountCard";
import OfferStatusCountCard from "./CountCards/OfferStatusCountCard";
import OfferReviseCountCard from "./CountCards/OfferReviseCountCard";
import VendorMSACountCard from "./CountCards/VendorMSACountCard";
import OnboardCountCard from "./CountCards/OnboardCountCard";
import RenewalCountCard from "./CountCards/RenewalCountCard";
import ExitCountCard from "./CountCards/ExitCountCard";
import BGCStatusCountCard from "./CountCards/BGCStatusCountCard";

function ELCDashboard() {
  document.title = "ELC Dashboard | RTS";
  const pageContentRef = useRef(null);
  const dispatch = useDispatch();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [pageWidth, setPageWidth] = useState(0);
  const [status, setStatus] = useState(null);
  const [stage, setStage] = useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState({
    from: null,
    to: null,
  });

  useEffect(() => {
    dispatch(fetchPreOfferCounts({ dateFrom: null, dateTo: null }));
    dispatch(fetchSLACounts({ dateFrom: null, dateTo: null }));
    dispatch(fetchBGCCounts({ dateFrom: null, dateTo: null }));
  }, []);

  // Getting Width of Page
  useEffect(() => {
    const handleResize = (entries) => {
      for (let entry of entries) {
        if (entry.target === pageContentRef.current) {
          setPageWidth(entry.contentRect.width + 24);
        }
      }
    };

    const resizeObserver = new ResizeObserver(handleResize);

    if (pageContentRef.current) {
      resizeObserver.observe(pageContentRef.current);
    }

    return () => {
      if (pageContentRef.current) {
        resizeObserver.unobserve(pageContentRef.current);
      }
    };
  }, [pageContentRef]);

  return (
    <React.Fragment>
      <div className="page-content" ref={pageContentRef}>
        <div className="elc-dashboard-container">
          <Row className="mb-2">
            <Col
              lg={12}
              className="d-flex flex-row justify-content-between align-items-center"
            >
              <div>
                <span className="elc-dashboard-title">Dashboard</span>
              </div>
              <div>
                <Dropdown
                  isOpen={dropdownOpen}
                  toggle={() => setDropdownOpen(!dropdownOpen)}
                  direction="down"
                >
                  <DropdownToggle caret className="elc-calendar-dropdown">
                    <span className="mdi mdi-calendar-blank-outline me-2"></span>
                    {selectedDateRange?.from && selectedDateRange?.to ? (
                      <span>{`${selectedDateRange?.from} - ${selectedDateRange?.to}`}</span>
                    ) : (
                      <span>Select Date Range</span>
                    )}
                  </DropdownToggle>
                  <DropdownMenu className="elc-calendar-menu p-0 m-0">
                    <ELCDatePicker
                      setDropdownOpen={setDropdownOpen}
                      setSelectedDateRange={setSelectedDateRange}
                    />
                  </DropdownMenu>
                </Dropdown>
              </div>
            </Col>
          </Row>

          {/* Grid */}
          <div className="elc-grid">
            {/*Pre-Offer counters */}
            <PreOfferCountCard setStatus={setStatus} setStage={setStage} />
            <OfferCreationCountCard setStatus={setStatus} setStage={setStage} />
            <OfferReviewCountCard setStatus={setStatus} setStage={setStage} />
            <OfferApprovalCountCard setStatus={setStatus} setStage={setStage} />
            <ShareOfferCountCard setStatus={setStatus} setStage={setStage} />
            <OfferStatusCountCard setStatus={setStatus} setStage={setStage} />
            <BGCStatusCountCard setStatus={setStatus} setStage={setStage} />
            <OfferReviseCountCard setStatus={setStatus} setStage={setStage} />
            <VendorMSACountCard setStatus={setStatus} setStage={setStage} />
            <OnboardCountCard setStatus={setStatus} setStage={setStage} />
            <RenewalCountCard setStatus={setStatus} setStage={setStage} />
            <ExitCountCard setStatus={setStatus} setStage={setStage} />
          </div>
          <Row className="mt-3">
            <ELCTable
              status={status}
              selectedDateRange={selectedDateRange}
              setStatus={setStatus}
              stage={stage}
            />
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
}

export default ELCDashboard;
